// src/components/pages/EventManager/EventAdminPage.js

import React, { useState, useEffect } from "react";
import { db, auth } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useTheme } from "styled-components";

// MUI Components
import { Container, Typography, Collapse } from "@mui/material";

// Organisms
import HeaderWithButton from "./organisms/HeaderWithButton";
import EventForm from "./organisms/EventForm";
import EventsTable from "./organisms/EventsTable";

const EventAdminPage = () => {
  const [showForm, setShowForm] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (usr) => {
      if (usr) {
        const userDocRef = doc(db, "users", usr.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setIsAdmin(!!data.admin);
        }
      } else {
        setIsAdmin(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (!isAdmin) {
    return (
      <Container>
        <Typography variant="h5" color="error">
          Not authorized
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, fontFamily: "basic-sans" }}>
      {/* Header Section */}
      <HeaderWithButton
        title="Event Admin"
        buttonText={showForm ? "Cancel" : "+ Create a new event"}
        onButtonClick={() => setShowForm(!showForm)}
        theme={theme}
      />

      {/* Transitioned Form Section */}
      <Collapse in={showForm} timeout={500}>
        <EventForm
          theme={theme}
          onSuccessfulSubmit={() => setShowForm(false)}
        />
      </Collapse>

      {/* Events Table */}
      <EventsTable theme={theme} />
    </Container>
  );
};

export default EventAdminPage;
